// firebaseConfig.js

import { initializeApp, getApps } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAxWkg_71Hv5P92qEOCaCnPY7y_VHbzagI",
  authDomain: "million2trillion-4d06a.firebaseapp.com",
  projectId: "million2trillion-4d06a",
  storageBucket: "million2trillion-4d06a.appspot.com",
  messagingSenderId: "77254952767",
  appId: "1:77254952767:web:e638810c8e7cc879dd358a",
};

const app = !getApps().length ? initializeApp(firebaseConfig) : getApps()[0];

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: "select_account" });
